@if (avatarUrl()) {
  <img [src]="avatarUrl()" alt="avatar" class="user-name-avatar" />
} @else if (name()) {
  <div class="user-name-avatar">{{ name()!.charAt(0) }}</div>
}
